import { render, staticRenderFns } from "./Stock-statistique.vue?vue&type=template&id=b63ff280&"
import script from "./Stock-statistique.vue?vue&type=script&lang=js&"
export * from "./Stock-statistique.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/datepickers.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports